import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export function ThemeToggle() {
  const { theme, resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;

    const themeColorMeta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement;
    const statusBarMeta = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]') as HTMLMetaElement;

    if (resolvedTheme === "dark") {
      if (themeColorMeta) themeColorMeta.setAttribute("content", "#0a0e1a");
      if (statusBarMeta) statusBarMeta.setAttribute("content", "black");
    } else {
      if (themeColorMeta) themeColorMeta.setAttribute("content", "#ffffff");
      if (statusBarMeta) statusBarMeta.setAttribute("content", "default");
    }
  }, [resolvedTheme, mounted]);

  if (!mounted) {
    return null;
  }

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      className="fixed top-4 right-4 z-50"
    >
      <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}